export enum SupplierType {
  EXTERNE = 'EXTERNE',
  INTERNE = 'INTERNE',
  PARTICULIER = 'PARTICULIER',
  ETRANGER = 'ETRANGER',
}
